import PropTypes from "prop-types";
import { useEffect } from "react";
// rtl
import rtlPlugin from "stylis-plugin-rtl";
// emotion
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
// @mui
import { useTheme } from "@mui/material/styles";

import { useTranslation } from "react-i18next";
import useSettings from "src/hooks/useSettings";

// ----------------------------------------------------------------------

RtlLayout.propTypes = {
  children: PropTypes.node,
};

export default function RtlLayout({ children }) {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const { updateDirection, themeDirection } = useSettings();

  useEffect(() => {
    const currentLang = i18n.language || i18n.resolvedLanguage;
    const targetDirection = currentLang === "ar" ? "rtl" : "ltr";
    if (themeDirection !== targetDirection) {
      updateDirection(targetDirection);
    }
  }, [i18n.language, i18n.resolvedLanguage, themeDirection, updateDirection]);

  useEffect(() => {
    document.dir = theme.direction;
  }, [theme.direction]);

  const cacheRtl = createCache({
    key: theme.direction === "rtl" ? "rtl" : "css",
    stylisPlugins: theme.direction === "rtl" ? [rtlPlugin] : [],
  });

  return <CacheProvider value={cacheRtl}>{children}</CacheProvider>;
}
